import domReady from '../utils/domReady';

let expandChildren = 'p';

domReady.then(()=>{
    [...document.querySelectorAll('main > dl > dt')].forEach((element,key) => {
        let children = element.querySelectorAll(expandChildren);
        element.classList.add('loaded');
        if(children.length > 0){
            element.setAttribute('items',children.length);
        }
        element.addEventListener('click', () => toggleElement(element,!element.hasAttribute('toggled'),key));
    });
});

function toggleElement(element,on,key){
    [...element.parentNode.getElementsByTagName(element.tagName)].forEach((sibling)=>{
        if(sibling !== element) sibling.removeAttribute('toggled');
    });
    element[on ? 'setAttribute' : 'removeAttribute']('toggled','toggled');
}